import React from "react";
import { Link, useLocation } from "react-router-dom";
import Footer from "../../components/homepage/Footer";


export default function ApplyConfirmation() {
  const location = useLocation();
  const applicantName = location.state?.name || "Applicant";

  return (
    <>
    <div className="w-full min-h-screen flex flex-col items-center justify-center px-6 py-16">
      
      <div className="max-w-xl w-full bg-black/50 backdrop-blur-md border border-gray-200 rounded-2xl p-10 shadow-xl text-center">
        
        <h1 className="text-white text-5xl font-bold mb-4">
          Application Received
        </h1>

        <p className="text-gray-300 text-lg mt-4">
          Thank you, <span className="text-white font-semibold">{applicantName}</span>.
        </p>

        <p className="text-gray-400 text-md mt-3">
          Your application is now under review.  
          We will contact you soon with the next steps.
        </p>

        <Link
          to="/"
          className="inline-block mt-8 px-8 py-3 bg-neonTurquoise text-black font-bold rounded-full hover:scale-105 transition"
        >
          Back to Home
        </Link>
      </div>
    </div>
    <Footer />
    </>
  );
}
